export default "__VITE_ASSET__BrHggJMd__"